import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetArchivedResearcherProjectsRPC } from "./getArchivedResearcherProjectsRPC";

export class GetArchivedResearcherProjectsRPCClientImpl extends GetArchivedResearcherProjectsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetArchivedResearcherProjectsRPC.Request): Promise<LeoRPCResult<GetArchivedResearcherProjectsRPC.Response, GetArchivedResearcherProjectsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetArchivedResearcherProjects",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetArchivedResearcherProjectsRPC.ResponseDTO,
      GetArchivedResearcherProjectsRPC.Errors.ErrorsDTO,
      GetArchivedResearcherProjectsRPC.Response,
      GetArchivedResearcherProjectsRPC.Errors.Errors
    >(
      response,
      "project/GetArchivedResearcherProjects",
      GetArchivedResearcherProjectsRPC.Response.fromDTO,
      GetArchivedResearcherProjectsRPC.Errors.fromDTO
    );
  }
}
